import * as tslib_1 from "tslib";
import { EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var FcHorizontalBarChartComponent = /** @class */ (function () {
    function FcHorizontalBarChartComponent(fuseTranslationLoaderService) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.select = new EventEmitter();
        this.results = [];
        this.isLoading = true;
        this.showXAxis = true;
        this.showYAxis = true;
        this.gradient = false;
        this.showLegend = true;
        this.showXAxisLabel = true;
        this.showYAxisLabel = true;
        this.tooltipDisabled = false;
        this.colors = [];
        this.chartData = [];
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    FcHorizontalBarChartComponent.prototype.ngOnChanges = function (changes) {
        if ((changes.results && !changes.results.currentValue.length) || !changes.results) {
            return;
        }
        this.setPercentageOnItem();
        this.reorderChartColumnsDesc();
    };
    FcHorizontalBarChartComponent.prototype.setPercentageOnItem = function () {
        var highestValueItem = this.results.reduce(function (prev, current) {
            return (prev.value > current.value) ? prev : current;
        });
        var highestValue = highestValueItem.value;
        this.chartData = this.results.map(function (result) {
            var percentage = highestValue ? Math.round((result.value / highestValue) * 100) : 0;
            return tslib_1.__assign({}, result, { percentage: percentage });
        });
    };
    FcHorizontalBarChartComponent.prototype.reorderChartColumnsDesc = function () {
        this.chartData.sort(function (a, b) { return b.value - a.value; });
    };
    return FcHorizontalBarChartComponent;
}());
export { FcHorizontalBarChartComponent };
